import ThemeIcon from './component'

export default ThemeIcon
